/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Filter } from './Filter';
import {
    FilterFromJSON,
    FilterFromJSONTyped,
    FilterToJSON,
} from './Filter';
import type { MetaData } from './MetaData';
import {
    MetaDataFromJSON,
    MetaDataFromJSONTyped,
    MetaDataToJSON,
} from './MetaData';

/**
 * 
 * @export
 * @interface BodyDataExport
 */
export interface BodyDataExport {
    /**
     * 
     * @type {Array<Filter>}
     * @memberof BodyDataExport
     */
    filters?: Array<Filter>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BodyDataExport
     */
    columns?: Array<string>;
    /**
     * 
     * @type {MetaData}
     * @memberof BodyDataExport
     */
    metaData?: MetaData;
}

/**
 * Check if a given object implements the BodyDataExport interface.
 */
export function instanceOfBodyDataExport(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BodyDataExportFromJSON(json: any): BodyDataExport {
    return BodyDataExportFromJSONTyped(json, false);
}

export function BodyDataExportFromJSONTyped(json: any, ignoreDiscriminator: boolean): BodyDataExport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filters': !exists(json, 'filters') ? undefined : ((json['filters'] as Array<any>).map(FilterFromJSON)),
        'columns': !exists(json, 'columns') ? undefined : json['columns'],
        'metaData': !exists(json, 'meta_data') ? undefined : MetaDataFromJSON(json['meta_data']),
    };
}

export function BodyDataExportToJSON(value?: BodyDataExport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filters': value.filters === undefined ? undefined : ((value.filters as Array<any>).map(FilterToJSON)),
        'columns': value.columns,
        'meta_data': MetaDataToJSON(value.metaData),
    };
}

